import { createContext, useContext, useState, useMemo } from "react";

const StandaloneContext = createContext({
  isStandalone: false,
  isAuthenticating: false,
  setIsStandalone: () => {},
  setIsAuthenticating: () => {},
});

export const useStandaloneContext = () => useContext(StandaloneContext);

export function StandaloneProvider({ children }) {
  const [isStandalone, setIsStandalone] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  const value = useMemo(
    () => ({ isStandalone, isAuthenticating, setIsStandalone, setIsAuthenticating }),
    [isStandalone, isAuthenticating]
  );

  return (
    <StandaloneContext.Provider value={value}>
      {children}
    </StandaloneContext.Provider>
  );
}

export default StandaloneContext;
